import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/auth/authSlice";
import cohortReducer from "../features/cohort/cohortSlice";

export default configureStore({
  reducer: {
    auth: authReducer,
    cohort: cohortReducer
  }
});
